import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const urn = "admin/stores";

const stores = axios.create({
  baseURL: queryParams.apiVersion + urn
});

export const storesApi = {
  getSettings(params) {
    return stores.get("/get_settings", params);
  },
  getStores(params) {
    return stores.get("", params);
  },
  createStore(params) {
    return stores.post("", params);
  },
  removeStore(id) {
    return stores.delete(`/${id}`);
  },
  updateStore(id, params) {
    return stores.put(`/${id}`, params);
  },
  getStoreDetails(params) {
    return stores.get("/get_stores_info", params);
  },
  getStoreDetailsWithActions(params) {
    return stores.get(`/get_info_with_actions`, { params });
  },
  exportActiveStores(params) {
    return stores.get("export_active", params);
  },
  recalculateStore(params) {
    return stores.post("recalculate", params);
  },
  reimportAndRecalculateStore(params) {
    return stores.post("reimport_and_recalculate", params);
  }
};
